import { useEffect, useRef, useState } from 'react';
import { useUrlInfo } from '@/utils/hooks';
import { useHistory } from 'react-router-dom';
import bookcenter from '@/api/bookcenter';
import Utils from '@/utils/utils';
import './index.scss';

function LoadingPage({ isLoaded, finished, showGuide = false }) {
  const { query = {}} = useUrlInfo();
  const history = useHistory();
  const progressRef = useRef(null);
  const loadedTimer = useRef(null);
  const loadingTimer = useRef(null);
  const sceneId = Utils.params2json(`${window.location.search}`.slice(1), '&').sceneId;
  const [isNextGuide, setIsNextGuide] = useState(false);
  const [loadingTitle, setLoadingTitle] = useState({});
  const [guideTitle, setGuideTitle] = useState({});
  const [loadingBg, setLoadingBg] = useState({});
  const [guideBg, setGuideBg] = useState({});
  const [centerImg, setCenterImg] = useState({});
  const [progress, setProgress] = useState({});
  const [loadingTips, setLoadingTips] = useState({});

  useEffect(() => {
    toGuide();
    //获取loading页配置
    bookcenter.listMiddlePage4Wechat({ sceneId, middleType: '1' }).then(data => {
      setLoadingTitle(data.find(item => item.controlType === 6) || {});
      setLoadingBg(data.find(item => item.controlType === 1) || {});
      setCenterImg(data.find(item => item.controlType === 2) || {});
      setProgress(data.find(item => item.controlType === 3) || {});
      setLoadingTips(data.find(item => item.controlType === 4) || {});
    });
    if(showGuide) {
      //获取引导页配置
      bookcenter.listMiddlePage4Wechat({ sceneId, middleType: '2' }).then(data => {
        setGuideTitle(data.find(item => item.controlType === 6) || {});
        setGuideBg(data.find(item => item.controlType === 5) || {});
      });
    }
    let width = 0;
    loadedTimer.current = setTimeout(loaded, 2000);
    loadingTimer.current = setInterval(() => {
      width += 6;
      if(width >= 90) {
        width = 90;
        clearInterval(loadingTimer.current);
      }
      progressRef.current && (progressRef.current.style.width = width + '%');
    }, 100);
    return () => {
      clearTimeout(loadedTimer.current);
      clearInterval(loadingTimer.current);
      sessionStorage.setItem('landing_page_type', '5');
    };
  }, []);

  useEffect(() => {
    if(guideBg.backgroundUrl) {
      //图片预加载
      new Image().src = Utils.getImg(guideBg.backgroundUrl);
    }
  }, [guideBg]);

  useEffect(() => {
    if(isLoaded) {
      setTimeout(() => {
        loaded();
      }, 500);
    }
  }, [isLoaded]);

  useEffect(() => {
    if(showGuide && isNextGuide) {
      guideTitle.content && (document.title = guideTitle.content);
    } else {
      loadingTitle.content && (document.title = loadingTitle.content);
    }
  }, [loadingTitle, guideTitle, showGuide, isNextGuide]);

  const toGuide = () => {
    const _search = '?' + Utils.json2params(query);
    const { isRays7Page } = query;
    history.replace(`/rayh5/book/${+isRays7Page === 1 ? 'old' : 'guide'}` + _search);
  };

  const loaded = () => {
    clearTimeout(loadedTimer.current);
    clearInterval(loadingTimer.current);
    progressRef.current && (progressRef.current.style.width = '100%');
    setTimeout(() => {
      if(!showGuide) {
        finished && finished();
      } else {
        setIsNextGuide(true);
        document.body.style.overflow = 'hidden';
      }
    }, 400);
  };
  const _finished = () => {
    finished && finished();
    document.body.style.overflow = 'auto';
  };

  const getStyles = (styleJson) => {
    let style = {};
    try {
      style = JSON.parse(styleJson);
    } catch(error) {}
    if(typeof style !== 'object') style = {};
    return style;
  };

  const getPercentum = (val) => {
    return val * 100 + '%';
  };

  useEffect(() => {
    // 没有配置引导页自动进入资源页
    if(isNextGuide && !guideBg.backgroundUrl) {
      _finished();
    }
  }, [isNextGuide, guideBg]);

  if(isNextGuide) {
    const { xStart, xEnd, yStart, yEnd } = guideBg;
    return <div className="loading-page" style={{ ...getStyles(guideBg.styleJson) }}>
      <div className="guide-bgimg">
        <div className="guide-bgimg-wrapper">
          <img src={Utils.getImg(guideBg.backgroundUrl)} />
          {
            xStart !== undefined ? <button style={{ left: getPercentum(xStart), top: getPercentum(yStart), width: getPercentum(xEnd - xStart), height: getPercentum(yEnd - yStart) }} onClick={() => _finished()} /> :
            <button className="guide-no-bg-btn" onClick={() => _finished()} />
          }
        </div>
      </div>
    </div>;
  } else {
    const loadingColor = getStyles(progress.styleJson).loadingColor;
    return <div className="loading-page" style={{ ...getStyles(loadingBg.styleJson), backgroundImage: `url(${Utils.getImg(loadingBg.backgroundUrl)})` }}>
      <div className="loading-page-content">
        <div className="loading-center-img-box" style={{ transform: `translateY(${-(getStyles(centerImg.styleJson).upOffset || 0)}px)` }}>
          {centerImg.backgroundUrl && <img src={Utils.getImg(centerImg.backgroundUrl)} />}
        </div>
        <div className="loading-page-progress-box" style={{ transform: `translateY(${-(getStyles(progress.styleJson).upOffset || 0)}px)` }}>
          {loadingColor && <div className="loading-page-progress" style={{ backgroundColor: getStyles(progress.styleJson).loadingBgColor }}>
            <div className="progress-content" ref={progressRef} style={{ backgroundColor: loadingColor }}>
              <div
                className="progress-animation"
                style={{
                  background: loadingColor && `repeating-linear-gradient(104deg,${loadingColor} 0,${loadingColor} 5px,rgba(255, 255, 255, 0.3) 6px,rgba(255, 255, 255, 0.3) 10px, ${loadingColor} 11px) 0/100% no-repeat`
                }}
              />
            </div>
          </div>}
        </div>
        <div className="loading-tips-box" style={{ transform: `translateY(${-(getStyles(loadingTips.styleJson).upOffset || 0)}px)` }}>
          {loadingTips.content && <div className="loading-tips" style={{ ...getStyles(loadingTips.styleJson) }}>{loadingTips.content}</div>}
        </div>
      </div>
    </div>;
  }

}

export default LoadingPage;